import React from "react";

export const EDASummaryTables = ({ summaryTable1, summaryTable2, summaryTable3 }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
      
      {/* Table 1 */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm flex flex-col overflow-hidden">
        <div className="p-4 border-b border-slate-100 shrink-0">
          <h3 className="text-lg font-semibold text-slate-800">{summaryTable1.title}</h3>
          <p className="text-sm text-slate-500 mt-0.5">{summaryTable1.subtitle}</p>
        </div>
        <div className="flex-1 overflow-x-auto [&::-webkit-scrollbar]:h-2 [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar-thumb]:rounded-full">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-left whitespace-nowrap">Component</th>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-right whitespace-nowrap">Value</th>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-right whitespace-nowrap">%</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {summaryTable1.rows.map((row, idx) => (
                <tr key={idx} className="hover:bg-slate-50/50">
                  <td className="py-2.5 px-4 whitespace-nowrap flex items-center gap-2 text-slate-800 font-medium">
                    <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: row.color }}></span>
                    {row.label}
                  </td>
                  <td className="py-2 px-4 whitespace-nowrap text-right relative min-w-[100px]">
                    <div className="absolute top-1.5 bottom-1.5 left-0 rounded-r-sm" style={{ width: `${row.percent}%`, backgroundColor: row.color, opacity: 0.15 }}></div>
                    <span className="relative z-10 text-slate-600">{row.value}</span>
                  </td>
                  <td className="py-2.5 px-4 whitespace-nowrap text-right text-slate-600 tabular-nums">{row.percent}%</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-slate-50 border-t border-slate-200">
              <tr>
                <td className="py-3 px-4 font-bold text-slate-900">Total</td>
                <td className="py-3 px-4 font-bold text-slate-900 text-right whitespace-nowrap">{summaryTable1.totalValue}</td>
                <td className="py-3 px-4 font-bold text-slate-900 text-right whitespace-nowrap">{summaryTable1.totalPercent}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Table 2 */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm flex flex-col overflow-hidden max-h-[350px]">
        <div className="p-4 border-b border-slate-100 shrink-0">
          <h3 className="text-lg font-semibold text-slate-800">{summaryTable2.title}</h3>
          <p className="text-sm text-slate-500 mt-0.5">{summaryTable2.subtitle}</p>
        </div>
        <div className="flex-1 overflow-auto [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar-thumb]:rounded-full">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 shadow-[0_1px_0_0_#e2e8f0] sticky top-0 z-10">
              <tr>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-left whitespace-nowrap">Grouping</th>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-right whitespace-nowrap">Qty</th>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-right whitespace-nowrap">Value</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {summaryTable2.rows.map((row, idx) => (
                <tr key={idx} className="hover:bg-slate-50/50">
                  <td className="py-2.5 px-4 text-slate-700 truncate max-w-[120px]" title={row.label}>{row.label}</td>
                  <td className="py-2.5 px-4 whitespace-nowrap text-right text-slate-600 tabular-nums">{row.qty}</td>
                  <td className="py-2 px-4 whitespace-nowrap text-right relative min-w-[100px]">
                    <div className="absolute top-1.5 bottom-1.5 left-0 rounded-r-sm bg-[#5443a3]/10" style={{ width: `${row.percent}%` }}></div>
                    <span className="relative z-10 text-slate-600">{row.value}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>    
        </div>
        <div className="bg-slate-50 border-t border-slate-200 px-4 py-3 shrink-0 flex items-center justify-between text-xs font-bold text-slate-900">
          <span>Total</span>
          <div className="flex justify-end gap-10 text-right min-w-[130px]">
            <span className="w-16 truncate">{summaryTable2.totalQty}</span>
            <span className="w-20 truncate">{summaryTable2.totalValue}</span>
          </div>
        </div>
      </div>

      {/* Table 3 */}
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm flex flex-col overflow-hidden max-h-[350px]">
        <div className="p-4 border-b border-slate-100 shrink-0">
          <h3 className="text-lg font-semibold text-slate-800">{summaryTable3.title}</h3>
          <p className="text-sm text-slate-500 mt-0.5">{summaryTable3.subtitle}</p>
        </div>
        <div className="flex-1 overflow-auto [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-thumb]:bg-slate-300 [&::-webkit-scrollbar-thumb]:rounded-full">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 shadow-[0_1px_0_0_#e2e8f0] sticky top-0 z-10">
              <tr>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-left whitespace-nowrap">Grouping</th>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-right whitespace-nowrap">Qty</th>
                <th className="py-2.5 px-4 text-xs font-semibold uppercase tracking-wider text-slate-700 text-right whitespace-nowrap">Value</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {summaryTable3.rows.map((row, idx) => (
                <tr key={idx} className="hover:bg-slate-50/50">
                  <td className="py-2.5 px-4 text-slate-700 truncate max-w-[120px]" title={row.label}>{row.label}</td>
                  <td className="py-2.5 px-4 whitespace-nowrap text-right text-slate-600 tabular-nums">{row.qty}</td>
                  <td className="py-2 px-4 whitespace-nowrap text-right relative min-w-[100px]">
                    <div className="absolute top-1.5 bottom-1.5 left-0 rounded-r-sm bg-[#5443a3]/10" style={{ width: `${row.percent}%` }}></div>
                    <span className="relative z-10 text-slate-600">{row.value}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="bg-slate-50 border-t border-slate-200 px-4 py-3 shrink-0 flex items-center justify-between text-xs font-bold text-slate-900">
          <span>Total</span>
          <div className="flex justify-end gap-10 text-right min-w-[130px]">
            <span className="w-16 truncate">{summaryTable3.totalQty}</span>
            <span className="w-20 truncate">{summaryTable3.totalValue}</span>
          </div>
        </div>
      </div>

    </div>
  );
};
